// src/LandingPage.js
import React from 'react';
import 'swiper/swiper-bundle.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './styles.css';
import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import CoursesSection from './CoursesSection';
import ResourcesSection from './ResourcesSection';
import TutorRegistration from './TutorRegistration';

const LandingPage = () => {
  React.useEffect(() => {
    AOS.init({ once: true });

    const images = document.querySelectorAll('.hero-image');
    let currentIndex = 0;

    if (images.length > 0) {
      setInterval(() => {
        images[currentIndex].style.opacity = 0;
        currentIndex = (currentIndex + 1) % images.length;
        images[currentIndex].style.opacity = 1;
      }, 5000); // Change image every 5 seconds
    }
  }, []);

  return (
    <div className="bg-black text-white">
      <HeroSection />
      <FeaturesSection />
      <CoursesSection />
      <ResourcesSection />
      <TutorRegistration />
    </div>
  );
};

export default LandingPage;